import { render, staticRenderFns } from "./emptyState.vue?vue&type=template&id=007f868d&"
import script from "./emptyState.vue?vue&type=script&lang=js&"
export * from "./emptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports